module.exports = __webpack_public_path__ + "static/media/map-pin-semi-filled.b773e108.svg";